import React, { useMemo, useRef } from 'react';
import { useTable, useSortBy } from 'react-table';
import getGPAColor from './getGPAColor.js';
import getPassRateColor from './getPassRateColor.js';
import getActualUnitsColor from './getActualUnitsColor.js';
import getGPAPerformanceColor from './getGPAPerformanceColor.js';
import StudentButton from './StudentButton';
import { useDownloadExcel } from 'react-export-table-to-excel';
import { ExportIcon, CaretCircleDownIcon, CaretCircleUpIcon } from '@phosphor-icons/react';
const defaultPropGetter = () => ({});

function Table({ columns, data, chartColors, studentProfile = { current: {} } }) {
  // console.log(columns);
  // console.log(data);
  // console.log(chartColors);
  const clamp = (v, lo=0, hi=4) => Math.min(Math.max(v, lo), hi);

  const memoizedColumns = useMemo(() => columns, [columns]);
  const memoizedData = useMemo(() => data, [data]);
  const thisTable = useRef();
  // console.log(memoizedColumns, memoizedData);
  const {
    getTableProps,
    getTableBodyProps,
    getHeaderProps = defaultPropGetter,
    getColumnProps = defaultPropGetter,
    getRowProps = defaultPropGetter,
    getCellProps = defaultPropGetter,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({
    columns: memoizedColumns,
    data: memoizedData,
  }, useSortBy);
  const { onDownload } = useDownloadExcel({
      currentTableRef: thisTable.current,
      filename: 'grade_academy_table_export',
      sheet: 'Data'
  })
 return (
  <div>
    <button onClick={onDownload} style={{ padding: '10px' }}>
      <ExportIcon size={24} /> Export to Excel
    </button>

    <div className="tableScroll">
      <table ref={thisTable} className="table center" {...getTableProps()}>
        <thead className="tableHeadSticky">
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th
                  className="sticky-thc"
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                >
                  {column.render('Header')}
                  <span>
                    {column.isSorted
                      ? (column.isSortedDesc
                          ? <CaretCircleDownIcon style={{ marginLeft: '5px' }} size={15} />
                          : <CaretCircleUpIcon style={{ marginLeft: '5px' }} size={15} />)
                      : ''}
                  </span>
                </th>
              ))}
            </tr>
          ))}
        </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map(row => {
          prepareRow(row);
          {/* console.log(row); */}
          return (
            <tr {...row.getRowProps(getRowProps(row))}>
              {row.cells.map(cell => {
                let bgColor = '';
                let cellContent = cell.value;
                let colColor = 'black';
                if (cell.column.id === 'studentID' && studentProfile.current[cell.value]) {
                    cellContent = 
                      <StudentButton id={cell.value} backgroundColor={getGPAColor(row.allCells[2].value)} studentProfile={studentProfile.current[cell.value] || 
                      [(<div style={{
                     overflow: "hidden", 
                      display: "flex",
                      flexDirection: "column",
                      width: "80vw",
                      margin: "0 auto",
                      border: "1px solid black",
                      borderRadius: "10px",
                    }}
                  >
                    <div style={{ padding: "10px", borderBottom: "1px solid #ddd", display: "flex", alignItems: "center" }}><span>This student has no data.</span></div>
                    </div>
                  )]} />;
                } else if (['avgBenefitUtil', 'projectedBenefitUtil'].includes(cell.column.id)) {
                  bgColor = getGPAColor(cell.value);
                } else if (['classAverageGrade', 'gradeEarned', 'termGPA', 'totalGPA', 'projectedGPA'].includes(cell.column.id)) {
                  bgColor = getGPAColor(cell.value);
                } else if (['composite'].includes(cell.column.id)) {
                    bgColor = getGPAColor(clamp(cell.value / 2));
                } else if (['gradeAverage'].includes(cell.column.id)) {
                  bgColor = getGPAColor(((cell.value - (-2)) / (2 - (-2))) * 2);
                } else if (['passRate'].includes(cell.column.id)) {
                  bgColor = getGPAColor((cell.value*4));
                } else if (['progressSlope'].includes(cell.column.id)) {
                  bgColor = getGPAColor((cell.value+2));
                } else if (['aboveOrBelowGrade', 'gradeDifference'].includes(cell.column.id)) {
                  bgColor = getGPAColor(((cell.value - (-2)) / (2 - (-2))) * 4);
                } else if (['avgPassedPerTerm', 'projectedClassDifficulty'].includes(cell.column.id)) {
                  bgColor = getGPAColor(cell.value/4);
                } else if (cell.column.id === "course" || cell.column.id === "class") {
                  try {
                    const courseName = String(cell.value ?? "");       // avoid undefined/null
                    const match = courseName.match(/^[A-Za-z]+/);      // no need for /i if you include a-z
                    const prefix = match?.[0];                         // string or undefined
                    console.log(courseName, match, prefix);
                    console.log(prefix);
                    bgColor = chartColors[prefix] || '#000';
                    console.log(bgColor);
                  } catch (e) {
                    console.error("Error processing course/class name:", e);
                  }
                } else if (cell.column.id === 'percentile') {
                  bgColor = getGPAColor(((cell.value/100)*4));
                } else {
                  bgColor = '#000';
                  colColor = 'white';
                }

                return (
                  <td
                    {...cell.getCellProps([
                      {
                        className: cell.column.className,
                        style: { backgroundColor: bgColor, color: colColor },
                      },
                      getColumnProps(cell.column),
                      getCellProps(cell),
                    ])}
                  >
                    {cell.render('Cell', { value: cellContent })}
                  </td>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
    </div>
    </div>
  );
}

export default Table;